import { Col } from "react-bootstrap";
import NextImage from "next/image";
import Link from "next/link";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const FooterOurRecognitions = ({ recognitions }) => {
	return (
		<Col sm={12} md={12} xl={12} lg={12}>
			<div className="footer-col our-recognitions">
				<div className="footer-col-title">
					<p>Our Recognitions</p>
				</div>
				<ul>
					{recognitions?.map(
						(ele) => {
							const recognitionsImage = ele?.badge?.url;
							return (
								<li key={`Recognitions-${ele.id}`}>
									<Link
										href={ele?.link?.href || "#"}
									// className="cursor-pointer"
									>
										<NextImage
											src={`${baseUrl}${recognitionsImage}`}
											alt={`${ele?.badge.alternativeText}`}
											rel="nofollow"
											width={0}
											height={0}
											sizes="100vw"
										/>
									</Link>
								</li>
							);
						}
					)}
				</ul>
			</div>
		</Col>
	);
};

export default FooterOurRecognitions;
